import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  useEffect(() => { document.title = "Contact — Xurray"; }, []);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent! We'll be in touch.");
    } catch {
      toast.error("Could not send your message. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Layout hideAd>
      <main className="max-w-xl mx-auto px-4 py-12">
        <Mail className="w-10 h-10 text-primary mb-3" aria-hidden="true" />
        <h1 className="font-display font-bold text-4xl mb-2">Contact Us</h1>
        <p className="text-muted-foreground mb-6">Have a question, partnership idea, or feedback? Send us a message and our team will respond as soon as possible.</p>
        <a href="mailto:contact@xurray.com" data-testid="contact-email-link" className="inline-flex items-center gap-2 mb-8 rounded-full border border-border bg-muted/40 px-4 py-2 text-sm font-medium hover:border-primary hover:text-primary transition-colors">
          <Mail className="w-4 h-4" /> contact@xurray.com
        </a>
        {sent ? (
          <p className="text-green-600 font-medium" data-testid="contact-success">✅ Thank you! Your message has been received.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
            <div><Label htmlFor="c-name">Name</Label><Input id="c-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" data-testid="contact-name" /></div>
            <div><Label htmlFor="c-email">Email</Label><Input id="c-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" data-testid="contact-email" /></div>
            <div><Label htmlFor="c-msg">Message</Label><Textarea id="c-msg" required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1" data-testid="contact-message" /></div>
            <Button type="submit" disabled={loading} className="rounded-full" data-testid="contact-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Message"}
            </Button>
          </form>
        )}
      </main>
    </Layout>
  );
}
